import { Button } from '@mui/material';

export const MessengerField = ({ connect, t }: any) => (
  <Button variant="contained" sx={{ background: '#50a28a', my: 1 }} onClick={connect}>
    {t('SIGN_IN_WITH')} {t('FACEBOOK')}
  </Button>
);
